<template>
	<section class="container marketing-section bt">
		<h2 class="heading-1 mb-300-md mb-200-smo text-align-center"> Historical share price </h2>
		<div class="col-10-md col-offset-1-md">
			<BasePlaceHolder :line-count="5" :placehold="loading">
				<IpoSharePriceChart class="mt-50" :ipo-price-history="ipoPriceHistory" :chart-height="400" />
			</BasePlaceHolder>
		</div>
	</section>
</template>

<script setup lang="ts">
import { getIpoPriceHistory } from '@api/ipo';
import { IpoPriceData } from 'types/ipo';
import IpoSharePriceChart from '@components/charts/ipo-share-price-chart.vue';
import { ref } from 'vue';

const loading = ref(true);

const ipoPriceHistory = ref<Array<IpoPriceData>>([]);

async function setup(): Promise<void> {
	ipoPriceHistory.value = await getIpoPriceHistory();
	loading.value = false;
}

setup();
</script>
